import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, CHECKOUT_URL, PACK_IMAGE, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 border-y-4 border-gold bg-cream" data-id="element-110" data-mp="8mdmfcb6rh3m">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-111" data-mp="dg86igupdy38">
        <p className="inline-block rounded-md bg-pitch px-2 py-0.5 font-sub text-sm font-extrabold leading-tight text-gold" data-id="element-112" data-mp="icoth7q626eq">
          Oferta especial — Sistema completo 6 en 1
        </p>
        <h2 id="oferta-titulo" className="mt-2 font-display text-[1.8rem] font-normal uppercase leading-[1.05] text-pitch sm:text-5xl" data-id="element-113" data-mp="rf7urneb0ayv">
          Comienza hoy desde cero y avanza a tu ritmo.
        </h2>

        <Reveal className="mt-3 overflow-hidden rounded-2xl border-4 border-dashed border-pitch bg-white text-pitch" data-id="element-114" data-mp="2t7dy8q52u21z">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block bg-pitch" data-id="element-115" data-mp="12nictk7lq9sy">
            <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos y 5 bonos incluidos`} className="block w-full" data-id="element-116" data-mp="xv8na5aefbr7" />
          </a>
          <div className="p-3" data-id="element-117" data-mp="oxev96jo349u">
            <p className="font-sub text-sm font-extrabold uppercase leading-tight text-field" data-id="element-118" data-mp="ou0u21mqp13z">
              {PRODUCT_NAME}
            </p>
            <p className="mt-1 inline-block rounded-md bg-gold px-2 py-0.5 font-display text-2xl uppercase leading-tight" data-id="element-119" data-mp="1gmru6n7jn9yi">
              6 Tomos + 5 Bonos
            </p>
            <p className="mt-1 text-xs font-semibold text-pitch/80 sm:text-sm" data-id="element-120" data-mp="1cnivr51k6nwm">
              🎁 Bonos valorados en{' '}
              <span className="line-through decoration-red-600 decoration-2" data-id="element-121" data-mp="172ed66g1x74">{BONUS_TOTAL}</span>
            </p>

            <p className="mt-2 inline-block rounded-full bg-pitch px-3 py-0.5 font-sub text-xs font-extrabold uppercase text-gold" data-id="element-122" data-mp="3scklj1xlg2xq">
              🔥 Oferta especial
            </p>
            <p className="mt-1 font-display text-6xl leading-none text-field sm:text-7xl" data-id="element-123" data-mp="2ng7k22elacp">
              <span className="text-3xl text-pitch sm:text-4xl" data-id="element-124" data-mp="3ktl5955firil">Hoy:</span>{' '}
              {PRICE}
            </p>
            <p className="mt-1 text-xs font-semibold text-pitch/80" data-id="element-125" data-mp="3oudc5rqtwkbp">
              Pago único • Sin mensualidades • Acceso Digital
            </p>

            <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3" data-id="element-126" data-mp="3b26zifmvwvh0">
              🚀 Sí, quiero el sistema completo por {PRICE}
            </CtaButton>
            <p className="mt-2.5 text-xs font-semibold text-pitch/80" data-id="element-127" data-mp="316dee7v3ntnm">
              Acceso Inmediato • Garantía de 7 Días
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}